import React, { useEffect } from 'react';
import useAuth from 'hooks/useAuth';
import { createContext, ReactNode, useContext } from 'react';
import { useGetAdminProfile, AdminProfileInfo } from 'api/admin';

interface AdminContextType {
  isLoading: boolean;
  error: any;
  currentAdminId: number;
  profile: AdminProfileInfo | null;
  profileLoading: boolean;
  refreshProfile: () => Promise<void>;
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

interface AdminProviderProps {
  children: ReactNode;
}

export function AdminProvider({ children }: AdminProviderProps) {
  const { user } = useAuth();
  const currentAdminId = Number(user?.id) || 0;
  const { getAdminProfile, profile, isLoading: profileLoading } = useGetAdminProfile();

  useEffect(() => {
    getAdminProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshProfile = async () => {
    await getAdminProfile();
  };

  const value = {
    isLoading: false,
    error: null,
    currentAdminId,
    profile,
    profileLoading,
    refreshProfile
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export function useAdminContext() {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error('useAdminContext must be used within a AdminProvider');
  }
  return context;
}
